import React from "react";

const SiteFooter = ({ offsetForSidebar = false }) => {
  const year = 2026;

  return (
    <footer
      className={`site-footer${offsetForSidebar ? " site-footer-offset" : ""}`}
      role="contentinfo"
    >
      <span>
        © {year} IEEE Study Groups. Developed by the IEEE Technical Team.
      </span>
    </footer>
  );
};

export default SiteFooter;
